import React from 'react';
import L from 'leaflet';
import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom';
import LeafletIcon from 'leaflet/dist/images/marker-icon.png';
import LeafletIconRetina from 'leaflet/dist/images/marker-icon-2x.png';
import LeafletIconShadow from 'leaflet/dist/images/marker-shadow.png';
import styled, { ThemeProvider, injectGlobal } from 'styled-components';
import { AppProvider } from './Context/AppContext';
import Header from './Components/Header/Header';
import Footer from './Components/Footer/Footer';
import ScrollToTop from './Components/ScrollToTop';
import {
  RouteHome,
  RouteLocationsList,
  RouteLocation,
  RouteFish,
  RouteNotFound,
  RouteAbout,
} from './Routes';

const themeVariables = {
  desktopBreakpoint: '1200px',
  white: '#fff',
  greyLight: '#ddd',
  grey: '#ccc',
  greyDark: '#333',
  black: '#000',
  blue: '#287edb',
};

/* eslint-disable no-unused-expressions */
injectGlobal`
  body {
    padding: 0;
    margin: 0;
    font-family: "Roboto", sans-serif;
    box-sizing: border-box;
  }

  h1,
  .h1 {
    font-size: 3rem;
  }

  h2,
  .h2 {
    font-size: 2.5rem;
    color: ${themeVariables.blue};
  }
`;
/* eslint-enable no-unused-expressions */

const StyledApp = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: repeat(3, auto);
  grid-template-areas: 'header'
  'body'
  'footer';
`;

// Workaround to get the default icon to load.
// https://github.com/PaulLeCam/react-leaflet/issues/255
/* eslint no-underscore-dangle: ["error", { "allow": ["_getIconUrl"] }] */
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: LeafletIconRetina,
  iconUrl: LeafletIcon,
  shadowUrl: LeafletIconShadow,
});

function App() {
  return (
    <ThemeProvider theme={themeVariables}>
      <AppProvider>
        <Router>
          <ScrollToTop>
            <StyledApp>
              <Header />

              <div className="Container">
                <Switch>
                  <Route exact path="/" component={RouteHome} />
                  <Route exact path="/about" component={RouteAbout} />
                  <Route exact path="/locations" component={RouteLocationsList} />
                  <Route exact path="/locations/:locationId" component={RouteLocation} />
                  <Route exact path="/fish/:fishId" component={RouteFish} />
                  <Route component={RouteNotFound} />
                </Switch>
              </div>

              <Footer />
            </StyledApp>
          </ScrollToTop>
        </Router>
      </AppProvider>
    </ThemeProvider>
  );
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js